import type { ToolOutput } from '../../services/api'
import { DataTable, type DataTableColumn } from '../../ds'

interface TableMessageProps {
  output: ToolOutput
}

type Row = Record<string, unknown> & { __row: number }

/** A table an answer carries, as the design system's compact `DataTable` (D-37). */
const TableMessage = ({ output }: TableMessageProps) => {
  if (!output.columns || !output.rows) {
    return null
  }

  const { title, columns, rows } = output
  const tableColumns: DataTableColumn<Row>[] = columns.map((col) => ({
    key: col.key,
    label: col.label,
    render: (row) => formatCellValue(row[col.key]),
  }))

  return (
    <DataTable<Row>
      columns={tableColumns}
      rows={rows.map((row, i) => ({ ...row, __row: i }))}
      rowKey="__row"
      caption={title}
      captionHidden={!title}
      stickyFirst={false}
      emptyText="No data available"
    />
  )
}

function formatCellValue(value: unknown): string {
  if (value === null || value === undefined) {
    return '-'
  }
  if (typeof value === 'number') {
    return value.toLocaleString()
  }
  if (typeof value === 'boolean') {
    return value ? 'Yes' : 'No'
  }
  if (value instanceof Date) {
    return value.toLocaleDateString()
  }
  return String(value)
}

export default TableMessage
